<template>
    <div class="patent-search display-flex flex-column p-sm w-100">
        <AonContainer class="display-flex flex-column flex-grow-1">
            <AonRow class="display-flex flex-column flex-grow-1">
                <div class="grid-holder w-100 display-flex flex-column flex-grow-1">
                    <div class="display-flex align-items-center justify-between mb-sm">
                        <h5 class="mb-0">Patent Search</h5>
                    </div>
                    <p class="mb-md">
                        Use the available filters to refine your patent search results.
                    </p>
                    <AonCol
                        class="grid-cols-12 display-flex flex-column flex-grow-1 position-relative"
                    >
                        <PatentList
                            inline
                            :allow-export="true"
                            :allow-pruning="false"
                            @close-patent-list="closeResults"
                        />
                    </AonCol>
                </div>
            </AonRow>
        </AonContainer>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, onBeforeMount } from 'vue'
import { usePatentViewerStore } from '@/stores'
import PatentList from '@/components/patentViewer/PatentList.vue'

const patentViewerStore = usePatentViewerStore()

const closeResults = () => {
    patentViewerStore.resetState()
}

onBeforeMount(() => {
    patentViewerStore.resetState()
    patentViewerStore.setHideMappedProducts(true)
    patentViewerStore.listViewType = 'screener'
})

onUnmounted(() => {
    patentViewerStore.setHideMappedProducts(false)
})
</script>

<style lang="scss" scoped>
.patent-search {
    height: calc(100% - 84px); // minus header + padding
    position: relative;
}
</style>
